import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { incorporadoraService } from '../../services/incorporadoraService';
import { Incorporadora } from '../../types/incorporadora';
import { IncorporadoraForm } from './IncorporadoraForm';

export const EditarIncorporadora: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [incorporadora, setIncorporadora] = useState<Incorporadora | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchIncorporadora = async () => {
      if (!id) {
        setError('ID da incorporadora não fornecido');
        setLoading(false);
        return;
      }

      try {
        const data = await incorporadoraService.getById(parseInt(id));
        setIncorporadora(data);
      } catch (err) {
        setError('Erro ao carregar incorporadora.');
      } finally {
        setLoading(false);
      }
    };

    fetchIncorporadora();
  }, [id]);

  if (loading) {
    return <div>Carregando...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  if (!incorporadora) {
    return <div>Incorporadora não encontrada.</div>;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <IncorporadoraForm incorporadora={incorporadora} isEditing={true} />
    </div>
  );
};
